import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { checkSecurity } from 'components/config/Security';

import Content from 'components/page/Content/Content';
import { TrainingProvider } from "context/ContextTraining";
import { TrainingSearchProvider } from 'context/ContextTrainingSearch';
import { TrainingSearchResultProvider } from 'context/ContextTrainingSearchResult';

import TrainingDetails from '../TrainingDetails';
import TrainingStaffingDetails from './TrainingStaffingDetails';

import 'styles/TrainingStaffing.css';

const TrainingStaffing = () => {
  const navigate = useNavigate();


  useEffect(() => {
    // CHECK SECURITY
    checkSecurity(navigate, 'TrainingStaffin');
  }, []);


  return (
    <Content>
      <TrainingProvider>
        <TrainingSearchProvider>
          <TrainingDetails />
          <TrainingSearchResultProvider>
            <TrainingStaffingDetails />
          </TrainingSearchResultProvider>
        </TrainingSearchProvider>
      </TrainingProvider>
    </Content>
  );
}

export default TrainingStaffing;